import { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import { FaPhone, FaEnvelope, FaIdCard, FaFacebookSquare } from 'react-icons/fa'
import './FullContactPage.css'

function FullContactPage() {
    const form = useRef()
    const [sent, setSent] = useState(false)
    const [error, setError] = useState(false)

    const sendEmail = (e) => {
        e.preventDefault()
        emailjs.sendForm('KarinVRealtor', 'RealtorSite', form.current, 'uXWS0TjheyCb0F7VC')
            .then(() => {
                e.target.reset()
                setSent(true)
                setTimeout(() => setSent(false), 4000)
            }, () => {
                setError(true)
                setTimeout(() => setError(false), 4000)
            })
    }

    return (
        <div className="fullContactPage">

            <div className="contact-hero">
                <div className="contact-hero-overlay">
                    <p className="contact-hero-label">Let's Connect</p>
                    <h1 className="contact-hero-title">Contact Me</h1>
                </div>
            </div>

            <div className="contact-body">

                <div className="contact-info-panel">
                    <img src="/headshots/karin small.jpg" alt="Karin Vantuchova" className="contact-headshot" />
                    <h2 className="contact-agent-name">Karin Vantuchova</h2>
                    <p className="contact-agent-title">Licensed Real Estate Agent</p>

                    <div className="contact-details">
                        <div className="contact-detail-row">
                            <FaPhone className="contact-detail-icon" />
                            <span>951-775-0765</span>
                        </div>
                        <div className="contact-detail-row">
                            <FaEnvelope className="contact-detail-icon" />
                            <span>KarinVRealtor@gmail.com</span>
                        </div>
                        <div className="contact-detail-row">
                            <FaIdCard className="contact-detail-icon" />
                            <span>BRE# 01919715</span>
                        </div>
                        <div className="contact-detail-row">
                            <FaFacebookSquare className="contact-detail-icon" />
                            <a href="https://facebook.com/californialuxuryliving" target="_blank" rel="noreferrer">
                                CaliforniaLuxuryLiving
                            </a>
                        </div>
                    </div>
                </div>

                <div className="contact-form-panel">
                    <h3 className="contact-form-title">Send a Message</h3>
                    <p className="contact-form-sub">Fill out the form and I'll get back to you as soon as possible.</p>

                    <form ref={form} onSubmit={sendEmail} className="contact-form">
                        <div className="form-group">
                            <label htmlFor="user_name">Name</label>
                            <input type="text" id="user_name" name="user_name" placeholder="Your full name" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="user_email">Email</label>
                            <input type="email" id="user_email" name="user_email" placeholder="your@email.com" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone_number">Phone</label>
                            <input type="number" id="phone_number" name="phone_number" placeholder="Your phone number" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" name="message" rows="5" placeholder="How can I help you?" required></textarea>
                        </div>
                        <button type="submit" className="contact-submit">Send Message</button>
                        {sent && <p className="form-feedback success">Message sent! I'll be in touch soon.</p>}
                        {error && <p className="form-feedback error">Something went wrong. Please try again.</p>}
                    </form>
                </div>

            </div>
        </div>
    )
}

export default FullContactPage
